import { Navigate } from 'react-router';
import { useAuth } from '@/hooks/useAuth';
import { Loader2 } from 'lucide-react';

interface AdminGuardProps {
  children: React.ReactNode;
}

export default function AdminGuard({ children }: AdminGuardProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className='flex min-h-screen items-center justify-center' style={{ background: '#07110D' }}>
        <Loader2 className='h-8 w-8 animate-spin' style={{ color: '#7CFF6B' }} />
      </div>
    );
  }

  if (!user || user.role !== 'admin') {
    return <Navigate to='/dashboard' replace />;
  }

  return <>{children}</>;
}
